module.exports = __webpack_public_path__ + "img/icon8.f52f2ab6.png";